import BaseUrl from "../component/BaseUrl";

export const get = async (search) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.get(`/api/Account/GetAllInHouseUsers?name=${search}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const getOnlineUsers = async (search) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.get(`/api/Account/GetAllOnlineUsers?name=${search}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}
// upload img

export const userImgUplod = async (body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.post(`/api/Account/UploadProfilePicture`, body, config);
        return response;
    } catch (err) {
        return err.response
    }
}
// createUsers
export const createInHouseUser = async (body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.post("/api/Account/CreateUser", body, config);
        return response;
    } catch (err) {
        return err.response
    }
}

// get single users

export const getSingleUser = async (id) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.get(`/api/Account/GetUserById/${id}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}

// update users

export const updateTheUser = async (body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.put("/api/Account/UpdateUser", body, config);
        return response;
    } catch (err) {
        return err.response
    }
}

//  delete


export const deleteTheUser = async (id) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.delete(`/api/Account/DeleteUser/${id}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}
// block
export const blockUser = async (id, body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.put(`/api/Account/BlockUser/${id}`, body, config);
        return response;
    } catch (err) {
        return err.response
    }
}
export const unBlockUser = async (id, body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.put(`/api/Account/UnBlockUser/${id}`, body, config);
        return response;
    } catch (err) {
        return err.response
    }
}

// get therapist for inhouse users only

export const getManagerAndTherapist = async (id) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.get(`/api/Users/GetManagerAndTherapist/${id}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}
export const updateManagerAndTherapist = async (body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.put(`/api/Users/UpdateManagerAndTherapist`, body, config);
        return response;
    } catch (err) {
        return err.response
    }
}